import { Link } from "react-router-dom";
import { ShieldCheck, ShieldAlert, ShieldX, ArrowRight } from "lucide-react";

const ICON = { ok: ShieldCheck, warn: ShieldAlert, fail: ShieldX };
const TONE = { ok: "text-emerald-400", warn: "text-amber-400", fail: "text-red-400" };

export const SecurityItem = ({ item }) => {
  const Icon = ICON[item.status];
  return (
    <li className="flex gap-3 py-2.5 border-b border-[var(--color-border,#27272a)] last:border-0" data-testid={`security-item-${item.id}`}>
      <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${TONE[item.status]}`} />
      <div className="min-w-0">
        <p className="text-sm font-bold">{item.label}</p>
        <p className="text-xs opacity-70">{item.detail}</p>
        {item.fix && <p className="text-xs mt-1 text-[#c084fc]">Oprava: {item.fix}</p>}
      </div>
    </li>
  );
};

export const SecurityList = ({ security }) => (
  <>
    <div className="flex items-end gap-2 mb-3">
      <span className="text-4xl font-black font-mono" data-testid="security-score">{security.score}</span>
      <span className="text-sm opacity-60 pb-1">/ 100 · {security.issues} na opravu</span>
    </div>
    <ul>{security.items.map((i) => <SecurityItem key={i.id} item={i} />)}</ul>
    <p className="text-[11px] opacity-50 mt-3">{security.note}</p>
  </>
);

export default function SecuritySection({ security }) {
  if (!security) return null;
  return (
    <div className="border border-[var(--color-border)] bg-[var(--color-surface)]" data-testid="security-section">
      <div className="p-4 border-b border-[var(--color-border)] bg-[var(--color-bg)] flex items-center gap-2">
        <ShieldCheck className="w-5 h-5 text-[#a855f7]" />
        <h3 className="font-bold font-['Chivo']">Bezpečnosť a dôveryhodnosť webu</h3>
      </div>
      <div className="p-4">
        <SecurityList security={security} />
        <Link to="/bezpecnost-webu" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#a855f7] hover:underline" data-testid="security-monitor-link">
          Sledovať bezpečnosť každý týždeň za €19/mes <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
